import React from 'react';
import { ActionProps } from './Action.types';

export const Action = ({ children }: ActionProps) => {
  return React.cloneElement(children, {
    style: {
      ...children.props.style,
      position: 'relative',
      zIndex: 1,
    },
  });
};

Action.displayName = 'Action';
